import { Directive } from '@angular/core';
import { ElementRef, Renderer2, HostListener } from '@angular/core';

@Directive({
  selector: '[appNoNegative]'
})
export class NoNegativeDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.setAttribute(this.el.nativeElement, 'min', '0');
    console.log('im called')
  }

  @HostListener('keypress', ['$event']) avoidMinus(event: KeyboardEvent) {
    if (event.keyCode === 45) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event']) preventNegativeValue(event: Event) {
    const input = this.el.nativeElement as HTMLInputElement;
    if (parseFloat(input.value) < 0) {
      input.value = '0';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/no-negative.directive.ts